import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@services/auth/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class PushFrontService {
    private readonly URL_SEND_ONE = `${environment.urlBackend}/push/sendPushToToken`;
    private readonly URL_SEND_MANY = `${environment.urlBackend}/push/sendPushToManyTokens`;
    private readonly URL_SEND_PLAN = `${environment.urlBackend}/push/sendPushByPlan`;

    constructor(
        private http: HttpClient,
        private auth: AuthService,
    ) {}

    private async getAuthHeaders() {
        const jwt = await this.auth.loadJwToken();
        return new HttpHeaders({
            'x-token': jwt || '',
        });
    }

    // masivo real: backend busca tokens y envía en lotes
    async sendPushMasivo(payload: { title?: string; body?: string }) {
        const headers = await this.getAuthHeaders();

        return this.http
            .post<{
                response: {
                    ok: boolean;
                    totalUsuarios?: number;
                    totalTokens: number;
                    batches?: number;
                    successCount: number;
                    failureCount: number;
                    estado: string;
                };
            }>(
                this.URL_SEND_MANY,
                {
                    title: payload.title || '📲 Signo Médico',
                    body: payload.body || 'Push masivo desde backend 📢',
                },
                { headers },
            )
            .toPromise();
    }

    async sendPustToken(payload: {
        token: string;
        title?: string;
        body?: string;
        usuario?: string;
    }) {
        const headers = await this.getAuthHeaders();

        return this.http
            .post(
                this.URL_SEND_ONE,
                {
                    token: payload.token,
                    title: payload.title || '📲 Signo Médico',
                    body: payload.body || 'Push backend → celu real 🚀',
                    usuario: payload.usuario || '6793a3dea49e770f810902ed',
                },
                { headers },
            )
            .toPromise();
    }

    async sendPushPorPlan(payload: {
        title?: string;
        body?: string;
        planId: string;
    }) {
        const headers = await this.getAuthHeaders();

        return this.http
            .post<any>(`${this.URL_SEND_PLAN}/sendPushByPlan`, payload, {
                headers,
            })
            .toPromise();
    }
}
